import request from '@/api/request'

export default {
    getStatus(taskId) {
        return request({
            url: `/pmx/status/${taskId}`,
            method: 'get'
        })
    }
}
